// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  jubiliClientId: "7nd1k2f5s2gc8ioeubpvvqv5pm",
  backOfficeClientId: "5i745r8dvj1tt2feus4shjfcfo",
  builkClientId:   "4k10lm6gflmi8j718ahqfil925",
  apiAuthURL: "https://auth.builk.com/",
  apiJubiliURL: "https://jubili-api-prod.builk.com/",
  // apiJubiliURL: "https://jubili-api-test-hotfix.builk.com/",
  apiBuilkURL: "https://cost-api.builk.com/",
  jubiliPathS3: "https://s3-bkk.nipa.cloud/fm-jubili/TEST/",
  jubiliPathS3NewFormat: "https://s3-bkk.nipa.cloud/fm-jubili/",
  apiCartographerUrl: "https://peqhyjpf36.execute-api.ap-southeast-1.amazonaws.com/Prod/api/",
  firebaseConfig: {
    apiKey: "AIzaSyBtvZWDqJlWW0JGx8GKOkmid7WuHf_nYD4",
    authDomain: "builkbackoffice.firebaseapp.com",
    databaseURL: "https://builkbackoffice.firebaseio.com",
    projectId: "builkbackoffice",
    storageBucket: "builkbackoffice.appspot.com",
    messagingSenderId: "781578275759",
    policyCollection: "policies-prod"
  },
  apiIntakesURL: "https://intake-api.builk.com"
};
